import { SpotCrowdedLabel } from '@/components/molecules/spots/SpotCrowdedLabel'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface SpotSwiperSlideProps {
  name: string | string[]
  image?: string
  address: string
  isStamp: boolean
  sheetNames?: string[]
  isCoupon: boolean
  stamp?: Api.StampInSpot
  spotCrowded?: Api.SpotCrowded
}

export const SpotSwiperSlide = ({
  name,
  image,
  address,
  isStamp,
  sheetNames,
  isCoupon,
  stamp,
  spotCrowded,
}: SpotSwiperSlideProps) => {
  const { t } = useTranslation()
  return (
    <div className="border-gray-200 c-swiper_contents flex items-center border-b pt-2 pb-1 min-h-[83px]">
      <div className="c-thumbnail_min-wrap">
        <span className="c-thumbnail_min block">
          <img src={image ? image : ''} alt="" />
        </span>
      </div>
      <div className="ml-2">
        <div className={'flex items-center'}>
          <div>
            <p className="c_clamp c_clamp_10 text-xsss font-bold">{name}</p>
            <p className="c_clamp c_clamp_10 text-xs">{address}</p>
          </div>
          <div className="py-2 px-2 self-start">
            {spotCrowded && <SpotCrowdedLabel spotCrowded={spotCrowded} w={'w-12'} />}
          </div>
        </div>
        <div className="mt-1 flex flex-wrap items-center">
          {!isStamp ? (
            <p className="c-tag text-xss text-sub">{t('spot_detail.other_recommendation', 'その他おすすめ')}</p>
          ) : (
            <>
              {stamp ? (
                <p className="c-status mr-2 text-xss text-color01">
                  {`${stamp.isHas ? t('spot_detail.acquired', '獲得済み') : t('spot_detail.un_acquired', '未獲得')}`}
                </p>
              ) : (
                ''
              )}
              {sheetNames ? (
                <>
                  {sheetNames.map((v: string, i: number) => {
                    return (
                      <p className="c-tag c_clamp mr-2 mb-1 inline-block text-xss text-sub" key={v}>
                        {v}
                      </p>
                    )
                  })}
                </>
              ) : (
                ''
              )}

              {isCoupon && (
                <p className="c-tag c-tag--coupon c_clamp mr-2 mb-1 inline-block text-xss">
                  {t('spot_detail.coupon', 'クーポン')}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}
